<script setup lang="ts">
	import type { MarkdownHeading } from '~/composables/useMarkdownToc'

	defineProps<{
		headings: MarkdownHeading[]
	}>()

	defineEmits<{
		'scroll-to': [id: string]
	}>()
</script>

<template>
	<aside
		class="scrollbar-hide sticky top-28 hidden max-h-[calc(100vh-8rem)] w-64 shrink-0 overflow-y-auto pb-8 xl:block"
	>
		<h3 class="mb-4 text-xs font-semibold uppercase tracking-wider text-gray-900">On this page</h3>
		<nav class="relative space-y-1 before:absolute before:inset-y-0 before:left-0 before:w-px before:bg-gray-200">
			<button
				v-for="heading in headings"
				:key="heading.id"
				class="relative block w-full py-1.5 text-left text-sm transition-colors"
				:class="[
					heading.depth === 2
						? 'pl-4 font-medium text-gray-700 hover:text-primary-600'
						: 'pl-8 text-gray-500 hover:text-gray-900'
				]"
				@click="$emit('scroll-to', heading.id)"
			>
				{{ heading.text }}
			</button>
		</nav>
	</aside>
</template>

<style scoped>
	/* Hide scrollbar for cleaner sidebar */
	.scrollbar-hide::-webkit-scrollbar {
		display: none;
	}
	.scrollbar-hide {
		-ms-overflow-style: none;
		scrollbar-width: none;
	}
</style>
